import React, {PureComponent} from 'react'
import cn from "classnames"
import injectSheet from 'react-jss'
import ImageOrVideo from "../Widgets/ImageOrVideo"
import Caption from "../Widgets/Caption"
import Quote from "../Widgets/Quote"
import theme from "../../styles/theme"
import ShopTheLookLink from "../ShopThLook/ShopTheLookLink"

const CAPTION_MAX_WIDTH = 360
const MOBILE_CAPTION_ORDER = 1
const MOBILE_IMAGE_ORDER = 2
const MOBILE_QUOTE_ORDER = 3
const MOBILE_CONTAINER_ORDER = 3
const DESKTOP_IMAGE_ORDER = 1
const DESKTOP_QUOTE_ORDER = 0
const DESKTOP_CAPTION_ORDER = 2
const DESKTOP_CONTAINER_ORDER = 2
const CAPTION_MARGIN = "0.5em 0"

const hasCaptionContent = caption => Boolean(caption)
const hasQuoteContent = quote => Boolean(quote)
export const isQuoteWithoutCaption = item => hasQuoteContent(item.quote) && !hasCaptionContent(item.caption)

class FullWidthImageWithQuote extends PureComponent {

    render() {
        const {classes, classNames = {}, item} = this.props;
        const {image, video, link, quote, quote_attribution, caption, shop_the_look_title, shopItems, quote_location_horizontal} = item;
        const hasShopItems = shopItems && shopItems.length > 0;
        const shopTheLookImage = hasShopItems && ((image && image.desktop) || (video && video.image.desktop))
        const shouldRenderCaption = hasCaptionContent(caption);
        const shouldRenderQuote = hasQuoteContent(quote);

        return (
            <section className={cn(classes.fullWidthContainer, classNames.fullWidthContainer)}>
                <ImageOrVideo className={classes.image} images={image} video={video} link={!hasShopItems && link}>
                    {hasShopItems && <ShopTheLookLink title={shop_the_look_title} shopItems={shopItems} image={{desktop: shopTheLookImage}} horizontalPosition={quote_location_horizontal} />}
                </ImageOrVideo>
                <div className={cn(classes.container, isQuoteWithoutCaption(item) && classes.quoteOnlyContainer)}>
                    {shouldRenderQuote && <Quote key="quote" className={classes.quoteContainer} bodyClassName={classes.quoteBody} quote={quote} quote_attribution={quote_attribution} imageQuote={true}/> }
                    {shouldRenderCaption && <Caption key="caption" className={classes.caption} caption={caption}></Caption>}
                </div>
            </section>
        )
    }
}

const getHorizontalFlexDirection = (location) => {
    switch( location ) {
        case "Right":
            return "row-reverse"
        default:
            return "row";
    }
}

export default injectSheet(
    {
        fullWidthContainer: {
            display: "flex",
            flexDirection: "column",
            position: "relative",
            width: '100%',
            marginLeft: 'auto',
            marginRight: 'auto',
            padding: ({item: {image_size}}) => image_size === '100%' ? 0 : `0 ${theme.spacing.small}`,
            [theme.breakpoint('tablet')]: {
                padding: [0, theme.spacing.normal],
                maxWidth: '100%'
            },
            [theme.breakpoint('laptop')]: {
                maxWidth: ({item: {image_size}}) => image_size ? image_size : '100%'
            },
        },
        image: {
            order: MOBILE_IMAGE_ORDER,
            [theme.breakpoint("tablet")]: {
                order: DESKTOP_IMAGE_ORDER,
            }
        },
        caption: {
            maxWidth: CAPTION_MAX_WIDTH,
            order: MOBILE_CAPTION_ORDER,
            marginLeft: theme.spacing.small,
            marginRight: theme.spacing.small,
            [theme.breakpoint("tablet")]: {
                order: DESKTOP_CAPTION_ORDER,
                marginLeft: 0,
                marginRight: 0,
            }
        },
        quoteOnlyContainer: {
            [theme.breakpoint("tablet")]: {
                "&::after": {
                    content: '""',
                    maxWidth: CAPTION_MAX_WIDTH,
                    margin: CAPTION_MARGIN,
                    order: DESKTOP_CAPTION_ORDER,
                }
            }
        },
        quoteContainer: {
            boxSizing: "content-box",
            flexBasis: "auto",
            height: 0,
            position: "absolute",
            left: 0,
            right: 0,
            bottom: 0,
            order: MOBILE_QUOTE_ORDER,
            [theme.breakpoint("tablet")]: {
                flexBasis: "50%",
                height: "100%",
                position: "relative",
                left: "auto",
                right: "auto",
                bottom: "auto",
                marginRight: theme.spacing.small,
                order: DESKTOP_QUOTE_ORDER,
            }
        },
        quoteBody: {
            position: "absolute",
            bottom: 0,
            margin: 0,
            maxWidth: 480,
            [theme.breakpoint("tablet")]: {
                bottom: `-${theme.spacing.small}`,
            }
        },
        container: {
            height: ({item: {quote}}) => hasQuoteContent(quote) ? 0 : "auto",
            display: "contents",
            flexDirection: ({item:{quote_location_horizontal}}) => getHorizontalFlexDirection(quote_location_horizontal),
            justifyContent: "flex-start",
            order: MOBILE_CONTAINER_ORDER,
            [theme.breakpoint("tablet")]: {
                display: "flex",
                justifyContent: "space-around",
                order: DESKTOP_CONTAINER_ORDER,
            }
        }
    }
)(FullWidthImageWithQuote)



// WEBPACK FOOTER //
// ./src/components/Article/FullWidthImageWithQuote.js